export default __webpack_public_path__ + "static/media/resilience2.e1c567f0.svg";